import { render, staticRenderFns } from "./ScrimStats.vue?vue&type=template&id=0aad5388&scoped=true&"
import script from "./ScrimStats.vue?vue&type=script&lang=js&"
export * from "./ScrimStats.vue?vue&type=script&lang=js&"
import style0 from "./ScrimStats.vue?vue&type=style&index=0&id=0aad5388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad5388",
  null
  
)

export default component.exports